// extracted by mini-css-extract-plugin
export var defaultWrapper = "_iz-3";
export var downloadButton = "_iz-4";
export var fileContainer = "_iz-9 _iz-7";
export var fileContainerBase = "_iz-7";
export var fileContainerFixedHeight = "_iz-8 _iz-7";
export var fileInfo = "_iz-5";
export var fileInfoWidthRestricted = "_iz-6";
export var fileType = "_iz-1";
export var fileTypeName = "_iz-2";
export var image = "_iz-0";
export var link = "_iz-b";
export var overflowEllipsis = "_iz-a";